import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { ParticipantsSortBy, User, UserLike } from 'features/users/types';

const getLastNameSortKey = (name: string): string => {
  if (isPossiblePhoneNumber(name)) {
    return name;
  }
  const parts = name.trim().split(/\s+/);
  return parts[parts.length - 1];
};

export const sortUserAlphabetically =
  <T extends UserLike = User>(sortBy: ParticipantsSortBy) =>
  (a: T, b: T): number => {
    if (!a.name) {
      return 1;
    }
    if (!b.name) {
      return -1;
    }

    if (sortBy === 'lastName') {
      const keyA = getLastNameSortKey(a.name);
      const keyB = getLastNameSortKey(b.name);
      const result = keyA.localeCompare(keyB);
      return result !== 0 ? result : a.name.localeCompare(b.name);
    }

    return a.name.localeCompare(b.name);
  };
